import { Button, Popup } from '@quickmd-llc/design-system'
import {
  DISCARD_CHANGES_POP_UP_BODY_TEXT_1,
  DISCARD_CHANGES_POP_UP_BODY_TEXT_2,
  DISCARD_CHANGES_POP_UP_BODY_TEXT_GENERIC,
  DISCARD_CHANGES_POP_UP_DISCARD_BTN_TEXT,
  DISCARD_CHANGES_POP_UP_KEEP_EDITING_BTN_TEXT,
  DISCARD_CHANGES_POP_UP_TITLE_TEXT,
} from '@/utils/constants'

type DiscardChangesPopupProps = {
  isOpen: boolean
  /** Name of the thing being edited (state, service type, intake form, member). Omit (or pass
   * undefined) for a new, still-unnamed item to fall back to the generic copy. */
  entityName?: string | undefined
  /** Discard the edits and continue leaving the page. */
  onDiscard: () => void
  /** Dismiss the popup and stay on the page. Also fired on backdrop click / Escape. */
  onKeepEditing: () => void
}

/**
 * Shared unsaved-changes guard popup. Built on the design-system `Popup`, which renders in a portal
 * with a full-screen overlay. No close icon — the design only offers Discard changes / Keep editing.
 * Pair with `useDiscardChangesGuard` to wire up Cancel + nav-bar interception.
 */
export const DiscardChangesPopup = ({ isOpen, entityName, onDiscard, onKeepEditing }: DiscardChangesPopupProps) => (
  <Popup
    isOpen={isOpen}
    onClose={onKeepEditing}
    header={DISCARD_CHANGES_POP_UP_TITLE_TEXT}
    body={
      <span>
        {entityName ?
          `${DISCARD_CHANGES_POP_UP_BODY_TEXT_1} ${entityName} ${DISCARD_CHANGES_POP_UP_BODY_TEXT_2}`
        : DISCARD_CHANGES_POP_UP_BODY_TEXT_GENERIC}
      </span>
    }
    footer={
      <div className='flex justify-end gap-sp-1'>
        <Button priority='tertiary' onClick={onDiscard}>
          {DISCARD_CHANGES_POP_UP_DISCARD_BTN_TEXT}
        </Button>
        <Button priority='primary' onClick={onKeepEditing}>
          {DISCARD_CHANGES_POP_UP_KEEP_EDITING_BTN_TEXT}
        </Button>
      </div>
    }
  />
)
